export const hashString = (string) => btoa(unescape(encodeURIComponent(string)));

export const manageError = (error) => {
  // `error.responde` : la coquille rendait la condition toujours fausse,
  // donc TOUT échec s'affichait « Une erreur inconnue est survenue », y
  // compris les 400 dont l'API explique précisément la cause. Ça devient
  // visible avec le retrait d'un membre, où l'API distingue désormais une
  // collision de noms d'une vraie panne.
  // Un 401 n'est pas une panne, c'est le cas le plus ORDINAIRE de l'écran de
  // connexion : le mot de passe ne correspond pas. Il tombait dans « une erreur
  // inconnue est survenue », qui laisse croire à un incident et pousse à
  // écrire au soutien au lieu de réessayer.
  if (error.response && error.response.status === 401) {
    return 'Adresse courriel ou mot de passe incorrect.';
  }
  if (error.response && error.response.status === 400) {
    const { data } = error.response;
    // Un 400 de DRF vaut { champ: [message] }. Mais une requête en
    // `responseType: 'blob'` — l'export de la collection — rend un Blob, et
    // `Object.entries` d'un Blob est vide : sans ce garde-fou, l'alerte
    // s'afficherait vide.
    if (data && typeof data === 'object' && !(data instanceof Blob)) {
      const message = Object.entries(data)
        .map(([key, value]) => {
          const texte = Array.isArray(value) ? value[0] : value;
          // ⛔ Pas de préfixe sur les erreurs qui ne portent AUCUN champ.
          // DRF leur réserve ces deux clés, et « detail : Cet ouvrage est
          // prêté… » afficherait un mot d'API dans une phrase adressée à une
          // bibliothécaire. Le préfixe reste utile ailleurs : sur un
          // formulaire, il dit quel champ corriger.
          if (key === 'detail' || key === 'non_field_errors') {
            return texte;
          }
          return `${key} : ${texte}`;
        });
      if (message.length) {
        return message.join(', ');
      }
    }
  }
  console.error(error);
  return 'Une erreur inconnue est survenue.';
};

export const displayDate = (dateTimeString) => {
  const dateTime = new Date(dateTimeString);
  return dateTime.toLocaleDateString();
};

export const replaceObjectWithId = (array, newObject) => array.map((oldObject) => {
  if (oldObject.id === newObject.id) {
    return newObject;
  }
  return oldObject;
});

export const removeObjectWithId = (array, newObject) => array.filter(
  (oldObject) => oldObject.id !== newObject.id,
);
